import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';

export interface NewDocument {
  name: string;
  file: string;
}

export const studentDocumentsApi = createApi({
  reducerPath: 'studentDocumentsApi',
  baseQuery,
  tagTypes: ['studentDocument', 'studentTags'],
  endpoints: builder => ({
    getFileTags: builder.query<any, { search: string }>({
      query: ({ search }) => `/tagging/tags?q=${search}`,
      providesTags: ['studentTags'],
    }),
    getStudentDocuments: builder.query<
      any,
      { studentId: string; documentName: string }
    >({
      query: ({ studentId, documentName }) =>
        `/enrollment/students/${studentId}/documents?q=${documentName}`,
      providesTags: ['studentDocument'],
    }),

    createStudentDocument: builder.mutation<
      void,
      { newDocument: NewDocument; studentId: string }
    >({
      query: ({ newDocument, studentId }) => ({
        url: `/enrollment/students/${studentId}/documents`,
        method: 'POST',
        body: newDocument,
      }),
      invalidatesTags: ['studentDocument', 'studentTags'],
    }),

    updateStudentDocument: builder.mutation<void, any>({
      query: ({ studentId, documentId, updates }) => ({
        url: `/enrollment/students/${studentId}/documents/${documentId}`,
        method: 'PATCH',
        body: updates,
      }),
      invalidatesTags: ['studentDocument', 'studentTags'],
    }),

    deleteDocument: builder.mutation<
      void,
      { studentId: string; documentId: string }
    >({
      query: ({ studentId, documentId }) => ({
        url: `/enrollment/students/${studentId}/documents/${documentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['studentDocument', 'studentTags'],
    }),
  }),
});

export const {
  useGetFileTagsQuery,
  useGetStudentDocumentsQuery,
  useUpdateStudentDocumentMutation,
  useCreateStudentDocumentMutation,
  useDeleteDocumentMutation,
} = studentDocumentsApi;
